import type { DeviceConfigurationApi } from '@model/DeviceConfiguration';
import type {
  AnalysisVerificationResult,
  CreateSpectralAnalysisInput,
  SpectralAnalysisSnapshot,
} from '../types';
import { runSpectralAnalysis } from '../utils/spectralAnalysis';

const defaultVerification = (): AnalysisVerificationResult => ({
  status: 'not-run',
  notes: ['Verifica non ancora eseguita'],
});

export const buildSpectralAnalysisSnapshot = (
  input: CreateSpectralAnalysisInput,
  sessions: DeviceConfigurationApi[],
  author: string
): SpectralAnalysisSnapshot => {
  const selectedSessions = sessions.filter(session =>
    input.sessionIds.includes(session.id)
  );
  const pipeline = runSpectralAnalysis(selectedSessions);

  return {
    analysisId: '',
    name: input.name,
    description: input.description,
    author,
    createdAt: new Date().toISOString(),
    selectedSessions: input.sessionIds,
    excludedSessions: pipeline.excludedSessions,
    includedSessions: pipeline.validations.map(validation => {
      const spectral = pipeline.spectralResults.find(
        result => result.sessionId === validation.sessionId
      );

      if (!spectral) {
        throw new Error(
          `Missing spectral result for session ${validation.sessionId}`
        );
      }

      return {
        validation,
        spectral,
      };
    }),
    groupSummary: pipeline.groupSummary,
    verification: defaultVerification(),
  };
};
